var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.694,
    height: 20,
    viewBox: "0 0 19.694 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M15.98,20H3.714a2.011,2.011,0,0,1-1.98-1.717l-1.714-12A2,2,0,0,1,2,4h2.88a4.438,4.438,0,0,1,1.66-2.819,5.22,5.22,0,0,1,6.613,0A4.437,4.437,0,0,1,14.814,4h2.88a2,2,0,0,1,1.98,2.283l-1.715,12A2.009,2.009,0,0,1,15.98,20ZM2,6,3.714,18H15.98L17.694,6H14.847V8h-2V6h-6V8h-2V6ZM9.847,2A3.089,3.089,0,0,0,6.919,4h5.856A3.09,3.09,0,0,0,9.847,2Z",
    transform: "translate(0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.0405744e7f123a502bdae5cd0ef3ac03.svg";
export { ForwardRef as ReactComponent };